// Legacy compatibility component retained because App still imports it.
// AdminAIAssistantWidget now owns:
// - draggable/persistent positioning
// - the native AI Casting action
// - the viewport-safe casting intake overlay
//
// Keeping this component as a no-op avoids App import churn while ensuring
// there is only one Admin AI implementation and no second floating launcher.

export default function AdminAIWidgetDragController() {
  return null;
}
